import React from 'react';
import ReactGA from 'react-ga';
import img1 from '../../../assets/images/ingenico.png';
import img2 from '../../../assets/images/hid.png';
import img3 from '../../../assets/images/pax.png';

const Wideskyscrapper = () => {
  const handleClick = () => {
    ReactGA.event({
      category: 'Ads',
      action: 'Clicou em Banner Rodapé (Leaderboard)',
    });
  };

  return (
    <div className="three wide right aligned computer only column">
      <a
        onClick={handleClick}
        href="https://www.ingenico.com.br"
        target="_blank" rel="noreferrer noopener"
      >
        <img src={img1} alt="Lateral" className="ui image" />
      </a>
      <a
        onClick={handleClick}
        href="https://www.hidglobal.com.br"
        target="_blank" rel="noreferrer noopener"
      >
        <img src={img2} alt="Lateral" className="ui image" />
      </a>
      <a
        onClick={handleClick}
        href="http://www.paxbr.com.br"
        target="_blank" rel="noreferrer noopener"
      >
        <img src={img3} alt="Lateral" className="ui image" />
      </a>
    </div>
  );
};

export default Wideskyscrapper;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/Wideskyscrapper.js
 **/